import { render, staticRenderFns } from "./DealAlarmDialog.vue?vue&type=template&id=52675e38&scoped=true"
import script from "./DealAlarmDialog.vue?vue&type=script&lang=js"
export * from "./DealAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./DealAlarmDialog.vue?vue&type=style&index=0&id=52675e38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52675e38",
  null
  
)

export default component.exports